
<section class="card-header">
  <slot></slot>
</section>
